"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouletteAdapter = void 0;
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const lodash_1 = require("lodash");
const Adapter_1 = require("./Adapter");
const Types_1 = require("./Types");
const ParserService_1 = require("./ParserService");
class RouletteAdapter extends Adapter_1.Adapter {
    constructor(options, adapterOptions) {
        super(options);
        this.channels = [];
        this.adapterOptions = adapterOptions;
        if (lodash_1.isNil(adapterOptions)) {
            throw new Error(Types_1.BusErrors.MissingAdapterOptions);
        }
        if (lodash_1.isNil(adapterOptions.wheelId)) {
            throw new Error(Types_1.BusErrors.MissingWheelIdError);
        }
        this.setName();
        this.addInitialChannels();
    }
    addInitialChannels() {
        this.addChannel(Types_1.ChannelType.Product, this.options.productId);
    }
    getQuery() {
        const wheelId = this.adapterOptions.wheelId;
        return `wheelId=${wheelId}`;
    }
    setListeners() {
        if (this.instance) {
            this.instance.on('connect', () => {
                this.subscribe();
            });
            this.instance.on('disconnect', () => {
                if (this.instance) {
                    this.instance.off('message');
                }
            });
        }
    }
    subscribe() {
        if (this.instance) {
            this.instance.on('message', (payload) => {
                const payloadData = JSON.parse(payload);
                if (payloadData) {
                    ParserService_1.parseAndDispatchEvent(payloadData.type, payloadData, this.useCommonEventName, this.name, this.options.proxyEvents, this.options.bounceToFrames);
                }
                else {
                    console.warn('[BusService]: Invalid payload:', payload);
                }
            });
        }
    }
    unsubscribe() {
        if (this.instance) {
            this.instance.off(this.options.productId);
        }
    }
    setName() {
        this.name = Types_1.Adapters.RouletteAdapter;
    }
    getEndpoint() {
        switch (this.options.environment) {
            case 'production':
            // NAR/WAR returns environemnt property in those values
            case 'dc-en':
            case 'dc-de':
            case 'dc-ro':
            case 'dc-ro2':
            case 'dc-rs':
                return 'https://roulette-service.nsoft.com:8443';
            default:
                return 'https://roulette-api-dev.nsoft.com:8443';
        }
    }
    connect() {
        this.instance = socket_io_client_1.default(this.getEndpoint(), {
            transports: ['websocket'],
            query: this.getQuery(),
        });
        this.setListeners();
    }
    disconnect() {
        if (this.instance) {
            this.instance.disconnect();
        }
    }
    reconnect() {
        if (this.instance && this.instance.disconnected) {
            this.instance.connect();
        }
    }
    addChannel(channelType, channelName) {
        if (this.channels.length <= 0) {
            this.channels.push({
                channelType,
                channelName,
            });
            this.subscribe();
        }
    }
    removeChannel(channelType, channelName) {
        if (channelType === Types_1.ChannelType.Product && channelName === this.options.productId && this.channels.length > 0) {
            this.channels.splice(0, 1);
            this.unsubscribe();
        }
    }
    sendMessage(message) {
        console.warn(`${this.name}: ${Types_1.BusErrors.MethodNotImplementedError}`, message);
    }
    getState(message) {
        console.warn(`${this.name}: ${Types_1.BusErrors.MethodNotImplementedError}`, message);
        return new Promise((resolve) => resolve(undefined));
    }
}
exports.RouletteAdapter = RouletteAdapter;
//# sourceMappingURL=RouletteAdapter.js.map